import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { AlertModule } from "ngx-bootstrap/alert";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { ModalModule } from "ngx-bootstrap/modal";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { ProgressbarModule } from "ngx-bootstrap/progressbar";
import { PopoverModule } from "ngx-bootstrap/popover";
import { TabsModule } from "ngx-bootstrap/tabs";
import { NgSelectModule } from "@ng-select/ng-select";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AlertModule.forRoot(),
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ProgressbarModule.forRoot(),
    TimepickerModule.forRoot(),
    PopoverModule.forRoot(),
    TabsModule.forRoot(),
    NgSelectModule,
  ],
  exports: [
    AlertModule,
    BsDropdownModule,
    CollapseModule,
    TooltipModule,
    ModalModule,
    BsDatepickerModule,
    ProgressbarModule,
    TimepickerModule,
    PopoverModule,
    TabsModule,
    NgSelectModule,
  ],
})
export class BootstrapModule {}
